import { useState } from "react"
import Input from "../../../shared/components/form/input"
import Checkbox from "../../../shared/components/form/checkbox"
import Button from "../../../shared/components/Button/Button"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import './FormChecklistGroup.css'

function FormChecklistGroup({ handleSubmit, checklistGroupData, btnText, btCancelAction, title }) {

    const [checklistGroup, setChecklistGroup] = useState(checklistGroupData || { order: 0 })

    function handleChange(e) {
        setChecklistGroup(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    function handleChangeCheckbox(name, value) {
        setChecklistGroup(prev => ({ ...prev, [name]: value }))
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(checklistGroup)
    }

    return (
        <FormLayout requiredLegend
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">
                        {btnText || 'Salvar'}
                    </Button>
                    {btCancelAction && (
                        <Button variant="cancel" onClick={btCancelAction}>
                            Cancelar
                        </Button>
                    )}
                </>
            }
        >
            <FormSection label="Grupo">
                <div className="form-group">
                    <Input
                        required
                        text="Nome do grupo"
                        type="text"
                        name="name"
                        placeholder="Ex: Motor, Elétrica, Arrefecimento..."
                        handleOnChange={handleChange}
                        value={checklistGroup.name || ''}
                    />
                </div>
                <div className="form-group">
                    <Checkbox
                        text="Grupo desabilitado"
                        name="disabled"
                        handleOnChange={() => handleChangeCheckbox("disabled", !checklistGroup.disabled)}
                        check={checklistGroup.disabled || false}
                    />
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormChecklistGroup
